export enum KeRefButtonItemColors {
  Success = 'success',
  Primary = 'primary',
  Warning = 'warning',
  Danger = 'danger',
  Info = 'info',
  Secondary = 'secondary',
}
